export const EXTERNAL_REF_PARAM = 'external_ref';
export const EXTERNAL_REF_STORAGE_KEY = 'ap_external_ref';

const EXTERNAL_REF_PATTERN = /^[A-Za-z0-9._~:-]{1,128}$/;

export const isValidExternalRef = (value: unknown): value is string =>
  typeof value === 'string' && EXTERNAL_REF_PATTERN.test(value);

const getExternalRefFromSearch = (search: string) => {
  const value = new URLSearchParams(search).get(EXTERNAL_REF_PARAM);

  return isValidExternalRef(value) ? value : undefined;
};

export const captureExternalRef = (search: string) => {
  const externalRef = getExternalRefFromSearch(search);

  if (!externalRef) {
    return;
  }

  try {
    sessionStorage.setItem(EXTERNAL_REF_STORAGE_KEY, externalRef);
  } catch {
    // sessionStorage can be unavailable even in a browser context.
  }
};

export const resolveExternalRef = (search: string) => {
  const externalRef = getExternalRefFromSearch(search);

  if (externalRef) {
    return externalRef;
  }

  try {
    const storedExternalRef = sessionStorage.getItem(EXTERNAL_REF_STORAGE_KEY);

    return isValidExternalRef(storedExternalRef) ? storedExternalRef : undefined;
  } catch {
    return undefined;
  }
};

export const clearExternalRef = () => {
  try {
    sessionStorage.removeItem(EXTERNAL_REF_STORAGE_KEY);
  } catch {
    // sessionStorage can be unavailable even in a browser context.
  }
};
